import React, { useEffect, useState } from "react";
import { Input, InterfaceInput, InterfaceNameValue } from "@tiendanube/components";

function InputDelayed(props: InterfaceInput): JSX.Element {

    const [localValue, setLocalValue] = useState<string>(props.value || '');

    useEffect(() => {
        const { name, onChange } = props;
        const ref = setTimeout(() => onChange?.({ name, value: localValue }), 500);
        return () => { clearTimeout(ref) };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localValue]);

    const onChangeLocalValue = ({ value }: InterfaceNameValue) => {
        setLocalValue(value.replace(/[^\w\s]/gi, ''));
    }

    return <Input {...props} value={localValue} onChange={onChangeLocalValue} />
};

export default InputDelayed;